import React from 'react';

import ErrorList from 'ui-library/spec-editor/ErrorList';

interface AssaySchemaErrorListProps {
  errors: Array<string>;
  component: string;
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const AssaySchemaErrorList = (props: AssaySchemaErrorListProps) => (
  <ErrorList
    errors={props.errors.length ? props.errors : null}
    errorMessage={props.errors.length ? `Invalid ${props.component.toLowerCase()}` : null}
  />
);

export default AssaySchemaErrorList;
